// Copyright (c) StrangeBee 2024

import { AnalyzerOutput, ObservableOutput } from 'thehive-sdk';

type ParamsProps = { observableIds: string[]; analyzerId: string; cortexId: string };

const createTokenAnalyzer = (observableIds: any, analyzerId: any, cortexId: any) =>
    JSON.stringify({ observableIds, analyzerId, cortexId });

const addAnalyzer = (arr: any[], { observableIds, name, cortexId }: any) => [
    ...arr,
    { name, cortexId, value: createTokenAnalyzer(observableIds, name, cortexId) },
];

export const parseTokenAnalyzer = (token: string): ParamsProps => JSON.parse(token);

export const computeDataSelected = (items?: ObservableOutput[], analyzer?: AnalyzerOutput[]): Record<string, any> => {
    const dataObservableSelected = (items || []).reduce((acc, { dataType, _id }) => {
        if (!acc[dataType]) {
            acc[dataType] = { observableIds: [], analyzers: [] };
        }
        return { ...acc, [dataType]: { ...acc[dataType], observableIds: [...acc[dataType].observableIds, _id] } };
    }, {} as Record<string, any>);

    const dataTypeSelected = Object.keys(dataObservableSelected);

    analyzer?.forEach(({ dataTypeList, name, cortexIds }) => {
        dataTypeSelected.forEach((type) => {
            if (dataTypeList.includes(type)) {
                cortexIds.forEach((cortexId) => {
                    dataObservableSelected[type].analyzers = addAnalyzer(dataObservableSelected[type].analyzers, {
                        name,
                        observableIds: dataObservableSelected[type].observableIds,
                        cortexId,
                    });
                });
            }
        });
    });

    return dataObservableSelected;
};
